import { MapIcon } from '@heroicons/react/24/solid';
import { cn, useThemeStore } from '@navi-app/utils';
import { Button, KIND, SIZE } from 'baseui/button';
import { useState } from 'react';
import { useShallow } from 'zustand/react/shallow';
import { TILES } from './constants/map-tiles';
import MapTilesLayer from './map-tiles-layer';

type TMapTilesMenu = {
  listTiles: (typeof TILES)[keyof typeof TILES][];
  nexisUrl?: string;
  onTileChange?: (tile: (typeof TILES)[keyof typeof TILES]) => void;
};

const MapTilesMenu = ({ listTiles, onTileChange, nexisUrl }: TMapTilesMenu) => {
  const [isOpen, setIsOpen] = useState(false);
  const { mapTile, setMapTile } = useThemeStore(
    useShallow((state) => ({
      mapTile: state.mapTile,
      setMapTile: state.setMapTile,
    }))
  );

  const handleTileChange = (tile: (typeof TILES)[keyof typeof TILES]) => {
    setMapTile(tile);
    onTileChange?.(tile);
  };

  return (
    <>
      <MapTilesLayer nexisUrl={nexisUrl} />
      <div
        className="absolute bottom-4 right-2 z-[1000]"
        onMouseEnter={() => setIsOpen(true)}
        onMouseLeave={() => setIsOpen(false)}
      >
        {/* Map Icon Button */}
        {!isOpen && (
          <Button
            kind={KIND.secondary}
            className="!bg-white !shadow-lg"
            size={SIZE.compact}
          >
            <MapIcon className="w-5 h-5" />
          </Button>
        )}

        {/* Tiles Menu */}
        {isOpen && (
          <div className="absolute bottom-0 right-0 w-[200px] bg-white rounded-lg shadow-lg p-2">
            {listTiles.map((tile) => {
              const isSelected = mapTile === tile;
              let displayName = '';

              switch (tile) {
                case TILES.OSM_LIGHT:
                  displayName = 'Light (Default)';
                  break;
                case TILES.OSM_STANDARD:
                  displayName = 'Standard';
                  break;
                case TILES.LIVE_TRAFFIC_AZURE:
                  displayName = 'Live Traffic';
                  break;
                default:
                  displayName = tile;
              }

              return (
                <button
                  key={tile}
                  onClick={() => handleTileChange(tile)}
                  className={cn(
                    'w-full px-4 py-2 text-sm text-left rounded-md transition-colors',
                    isSelected
                      ? 'bg-blue-100 text-blue-700'
                      : 'hover:bg-gray-100 text-gray-700'
                  )}
                >
                  {displayName}
                </button>
              );
            })}
          </div>
        )}
      </div>
    </>
  );
};

export default MapTilesMenu;
